<template>
  <div class="container college">
    <div style="height:40px;display:flex; justify-content: space-between; fontSize:16px;fontWeight:700;align-items:center">
      <div>录取信息</div>

      <el-button type="primary"
                 :loading="loading"
                 v-if="loading">导出中...</el-button>
      <el-button icon="el-icon-download"
                 @click="handleExport"
                 v-else>导出</el-button>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="院校名称"
                      prop="college_keyword">
          <el-input v-model="query.college_keyword"
                    @input="collegeList(true)"
                    placeholder="输入院校名称"></el-input>
        </el-form-item>
        <el-form-item label="学院"
                      prop="academy_keyword">
          <el-input v-model="query.academy_keyword"
                    @input="collegeList(true)"
                    placeholder="输入学院名称"></el-input>
        </el-form-item>
        <el-form-item label="专业"
                      prop="college_keyword">
          <el-input v-model="query.major_keyword"
                    @input="collegeList(true)"
                    placeholder="输入专业名称"></el-input>
        </el-form-item>
        <el-form-item label="院校简介"
                      prop="college_introduct_exist_status">
          <el-select v-model="query.college_introduct_exist_status"
                     style="width:90px"
                     clearable
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="无"
                       value="0"></el-option>
            <el-option label="有"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="复试名单"
                      prop="second_exam_roster_exist_status">
          <el-select v-model="query.second_exam_roster_exist_status"
                     style="width:90px"
                     clearable
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="无"
                       value="0"></el-option>
            <el-option label="有"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取名单"
                      prop="recruit_prepare_exist_status">
          <el-select v-model="query.recruit_prepare_exist_status"
                     style="width:90px"
                     clearable
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="无"
                       value="0"></el-option>
            <el-option label="有"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调剂信息"
                      prop="adjust_info_exist_status">
          <el-select v-model="query.adjust_info_exist_status"
                     style="width:90px"
                     clearable
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="无"
                       value="0"></el-option>
            <el-option label="有"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参考书目"
                      prop="reference_book_exist_status">
          <el-select v-model="query.reference_book_exist_status"
                     style="width:90px"
                     clearable
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="无"
                       value="0"></el-option>
            <el-option label="有"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分数线"
                      prop="score_line_exist_status">
          <el-select v-model="query.score_line_exist_status"
                     style="width:90px"
                     clearable
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="无"
                       value="0"></el-option>
            <el-option label="有"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header"
           style="display:flex;justify-content: space-between;">
        <p class="title">信息列表</p>
        <div> 选择年份<el-select v-model="query.current_search_year"
                     style="width:90px;marginLeft:10px"
                     placeholder="请选择"
                     @change="collegeList(true)">
            <el-option label="2027年"
                       value="2027"></el-option>
            <el-option label="2026年"
                       value="2026"></el-option>
            <el-option label="2025年"
                       value="2025"></el-option>
            <el-option label="2024年"
                       value="2024"></el-option>
            <el-option label="2023年"
                       value="2023"></el-option>
            <el-option label="2022年"
                       value="2022"></el-option>
          </el-select></div>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  :header-cell-style="{
                textAlign: 'center',
                color: '#909399',
                fontFamily: 'PingFang SC',
                fontSize: '14px',
                fontWeight: '400',
                backgroundColor: '#F2F6FC',
              }"
                  :cell-style="{ fontSize: '13px' }"
                  border>
          <!-- @selection-change="handleSelectionChange" -->
          <!-- <el-table-column type="selection"
                           width="50"
                           align="center">
          </el-table-column> -->
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="province_area"
                           label="地区"
                           width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="college_name"
                           label="院校"
                           width="250"
                           align="center">
          </el-table-column>
          <el-table-column prop="academy_name"
                           label="学院"
                           width="220"
                           align="center">
          </el-table-column>
          <el-table-column prop="category_ids"
                           label="专业"
                           width="250"
                           align="left">
            <template slot-scope="scope">
              ({{scope.row.major_code}}){{scope.row.major_name}}
            </template>
          </el-table-column>
          <el-table-column prop="college_introduct_exist_status"
                           label="院校简介"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.college_introduct_exist_status==1"
                    @click="handleCollage(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    @click="handleCollage(scope.row)"
                    v-else>去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="second_exam_roster_exist_status"
                           label="复试名单"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.second_exam_roster_exist_status==1"
                    @click="handlesecondary(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handlesecondary(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="recruit_prepare_exist_status"
                           label="录取名单"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.recruit_prepare_exist_status==1"
                    @click="handleEnroll(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleEnroll(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="adjust_info_exist_status"
                           label="调剂信息"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.adjust_info_item_count>0"
                    @click="handleAdjust(scope.row)">{{scope.row.adjust_info_item_count}}条</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleAdjust(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="reference_book_exist_status"
                           label="参考书目"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.reference_book_exist_status==1"
                    @click="handleReference(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleReference(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="score_line_exist_status"
                           label="分数线"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.score_line_exist_status==1"
                    @click="handleGrade(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleGrade(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="second_subject_exist_status"
                           label="复试科目"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.second_subject_exist_status==1"
                    @click="handleSecondSubject(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleSecondSubject(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="degree_subject_exist_status"
                           label="同等学历科目"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.degree_subject_exist_status==1"
                    @click="handleDegreeSubject(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleDegreeSubject(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="second_book_exist_status"
                           label="复试参考书"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.second_book_exist_status==1"
                    @click="handleSecondBook(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleSecondBook(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="learn_span_exist_status"
                           label="学制"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.learn_span_exist_status==1"
                    @click="handleLearnSpan(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleLearnSpan(scope.row)">去录入</span>
            </template>
          </el-table-column>
          <el-table-column prop="learn_tuition_exist_status"
                           label="学费"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF;cursor: pointer;"
                    v-if="scope.row.learn_tuition_exist_status==1"
                    @click="handleLearnTuition(scope.row)">查看详情</span>
              <span style="color:#FF9D00;cursor: pointer;"
                    v-else
                    @click="handleLearnTuition(scope.row)">去录入</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <!-- 院校简介 -->
      <CollegeIntroduct :visible="isible"
                        @close="collegeClose"
                        :IntroductId="IntroductId"
                        :college_code="college_code"> </CollegeIntroduct>
      <!-- 复试名单 -->
      <Secondary :visible="secondaryVisible"
                 :year="query.current_search_year"
                 :secondaryDetail="secondaryDetail"
                 @close="secondaryClose"></Secondary>
      <!-- 录取名单 -->
      <Enroll :visible="enrollVisible"
              :enrollDetail="enrollDetail"
              :year="query.current_search_year"
              @close="enrollClose"></Enroll>
      <!-- 调剂信息 -->
      <Adjustment :visible="adjustVisible"
                  :adjustDetail="adjustDetail"
                  :year="query.current_search_year"
                  @close="adjustClose"></Adjustment>
      <!-- 分数线 -->
      <GradeLine :visible="gradeVisible"
                 :gradeDetail="gradeDetail"
                 :year="query.current_search_year"
                 @close="gradeClose"></GradeLine>
      <!-- 参考书目 -->
      <ReferenceBook :visible="refereVisible"
                     :refereDetail="refereDetail"
                     :year="query.current_search_year"
                     @close="refereClose"></ReferenceBook>
      <!-- 复试科目 -->
      <SecondSubject :visible="secondSubjectVisible"
                     :secondSubjectDetail="secondSubjectDetail"
                     :year="query.current_search_year"
                     @close="secondSubjectClose"></SecondSubject>
      <!-- 同等学历科目 -->
      <DegreeSubject :visible="degreeSubjectVisible"
                     :degreeSubjectDetail="degreeSubjectDetail"
                     :year="query.current_search_year"
                     @close="degreeSubjectClose"></DegreeSubject>
      <!-- 复试参考书 -->
      <SecondBook :visible="secondBookVisible"
                  :secondBookDetail="secondBookDetail"
                  :year="query.current_search_year"
                  @close="secondBookClose"></SecondBook>
      <!-- 学制 -->
      <LearnSpan :visible="learnSpanVisible"
                 :learnSpanDetail="learnSpanDetail"
                 :year="query.current_search_year"
                 @close="learnSpanClose"></LearnSpan>
      <!-- 学费 -->
      <LearnTuition :visible="learnTuitionVisible"
                    :learnTuitionDetail="learnTuitionDetail"
                    :year="query.current_search_year"
                    @close="learnTuitionClose"></LearnTuition>
    </div>
  </div>
</template>

<script>
import { collegeMajorList, collegeMajorExport } from '@/api/admission'
import CollegeIntroduct from '@/components/dialog/admission/intodctionInstitution'
import Secondary from '@/components/dialog/admission/secondary'
import Enroll from '@/components/dialog/admission/Enroll'
import Adjustment from '@/components/dialog/admission/Adjustment'
import GradeLine from '@/components/dialog/admission/gradeLine'
import ReferenceBook from '@/components/dialog/admission/referenceBook'
import SecondSubject from '@/components/dialog/admission/secondSubject'
import DegreeSubject from '@/components/dialog/admission/degreeSubject'
import SecondBook from '@/components/dialog/admission/secondBook'
import LearnSpan from '@/components/dialog/admission/learnSpan'
import LearnTuition from '@/components/dialog/admission/learnTuition'

export default {
  components: {
    CollegeIntroduct,
    Secondary,
    Enroll,
    Adjustment,
    GradeLine,
    ReferenceBook,
    SecondSubject,
    DegreeSubject,
    SecondBook,
    LearnSpan,
    LearnTuition,
  },
  data() {
    return {
      loading: false,
      query: {
        current_search_year: '2025',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      college_code: null,
      results: [],
      chooseList: [],
      secondaryDetail: {},
      IntroductId: null,
      enrollDetail: {},
      adjustDetail: {},
      gradeDetail: {},
      refereDetail: {},
      secondSubjectDetail: {},
      degreeSubjectDetail: {},
      secondBookDetail: {},
      learnSpanDetail: {},
      learnTuitionDetail: {},
      isible: false,
      secondaryVisible: false,
      enrollVisible: false,
      adjustVisible: false,
      gradeVisible: false,
      refereVisible: false,
      secondSubjectVisible: false,
      degreeSubjectVisible: false,
      secondBookVisible: false,
      learnSpanVisible: false,
      learnTuitionVisible: false,
    }
  },
  created() {
    this.collegeList()
    this.$store.dispatch('getAllColleges')
    this.$store.dispatch('getAdminList')
    this.$store.dispatch('getAllColleges')
  },
  methods: {
    collegeList(reset) {
      const params = Object.assign({}, this.query)
      if (reset) {
        params.pageIndex = 1
      }
      collegeMajorList(params).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
        console.log('res', res)
      })
    },
    handleExport() {
      this.loading = true
      const params = Object.assign({}, this.query)
      collegeMajorExport(params).then((res) => {
        if (res) {
          this.loading = false
          this.$message.success(`导出成功`)
          window.open(res.url)
        }
      })
    },

    handleCollage(row) {
      this.isible = true
      this.CollageDetail(row)
    },
    collegeClose() {
      this.isible = false
      this.collegeList()
    },
    // 复试
    handlesecondary(row) {
      this.secondaryVisible = true
      this.secondaryDetail = row
    },
    secondaryClose() {
      this.secondaryVisible = false
      this.collegeList()
    },
    // 录取
    handleEnroll(row) {
      this.enrollVisible = true
      this.enrollDetail = row
    },
    enrollClose() {
      this.enrollVisible = false
      this.collegeList()
    },
    //调剂
    handleAdjust(row) {
      this.adjustVisible = true
      this.adjustDetail = row
    },
    adjustClose() {
      this.adjustVisible = false
      this.collegeList()
    },
    gradeClose() {
      this.gradeVisible = false
      this.collegeList()
    },
    //分数线
    handleGrade(row) {
      this.gradeVisible = true
      this.gradeDetail = row
    },
    //参考书目
    handleReference(row) {
      this.refereVisible = true
      this.refereDetail = row
    },
    refereClose() {
      this.refereVisible = false
      this.collegeList()
    },
    //复试科目
    handleSecondSubject(row) {
      this.secondSubjectVisible = true
      this.secondSubjectDetail = row
    },
    secondSubjectClose() {
      this.secondSubjectVisible = false
      this.collegeList()
    },
    //同等学历科目
    handleDegreeSubject(row) {
      this.degreeSubjectVisible = true
      this.degreeSubjectDetail = row
    },
    degreeSubjectClose() {
      this.degreeSubjectVisible = false
      this.collegeList()
    },
    //复试参考书
    handleSecondBook(row) {
      this.secondBookVisible = true
      this.secondBookDetail = row
    },
    secondBookClose() {
      this.secondBookVisible = false
      this.collegeList()
    },
    //学制
    handleLearnSpan(row) {
      this.learnSpanVisible = true
      this.learnSpanDetail = row
    },
    learnSpanClose() {
      this.learnSpanVisible = false
      this.collegeList()
    },
    //学费
    handleLearnTuition(row) {
      this.learnTuitionVisible = true
      this.learnTuitionDetail = row
    },
    learnTuitionClose() {
      this.learnTuitionVisible = false
      this.collegeList()
    },
    // 院校简介详情
    CollageDetail(row) {
      this.college_code = row.college_code
      this.IntroductId = row.id
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.collegeList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.collegeList()
    },
  },
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .del-btn {
        display: flex;
        align-items: center;

        .btn-text {
          height: 20px;
          line-height: 20px;
          margin-right: 22px;
          padding-right: 16px;
          border-right: 1px solid #dcdfe6;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #606266;
          span {
            font-weight: 600;
            font-size: 18px;
            color: #303133;
            margin: 0 4px;
          }
        }
      }
    }
  }
}
</style>
